import type { RouterConfig } from '@nuxt/schema'

import getVoucherCheckoutRoutes from './router/voucher.checkout'
import getGetAwayCheckoutRoutes from './router/get-away.checkout'

export default {
  // https://router.vuejs.org/api/interfaces/routeroptions.html#routes
  routes(routes) {
    return [
      ...routes,
      ...getVoucherCheckoutRoutes(),
      ...getGetAwayCheckoutRoutes(),
    ]
  },
} satisfies RouterConfig
